function simpleHash(str) {
  let hash = 0;
  if (str.length === 0) return hash;

  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash; // Conversion en entier 32 bits
  }

  return Math.abs(hash);
}

function getFingerprint() {
  try {
    const browserData = {
      userAgent: navigator.userAgent,
      language: navigator.language,
      platform: navigator.platform,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      timestamp: Date.now(),
    };
    return simpleHash(JSON.stringify(browserData)).toString(16).substring(0, 8);
  } catch (error) {
    return Date.now().toString(36).substring(2, 10);
  }
}

function randomPartFunction(
  length = 16,
  characters = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789abcdefghijkmnpqrstuvwxyz',
) {
  let randomPart = '';
  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    randomPart += characters.charAt(randomIndex);
  }
  return randomPart;
}

export function generateUniqueSentryInviteId(length = 16, prefix = 'GUEST_') {
  let randomPart = randomPartFunction(length);

  // Récupération des données du navigateur
  let fingerprint = getFingerprint();

  // Combinaison du préfixe, de l'empreinte et de la chaîne aléatoire
  return `${prefix}${fingerprint}-${randomPart}`;
}
